import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'

import Tooltip from 'common/components/dataDisplay/Tooltip'
import Error from 'common/components/dataEntry/formik/FormItemError'
import Icon from 'common/components/general/Icon'

import './CreditCardPayment.less'

interface CreditCardProps {
  recurlyErrors: Map<string, string>
  hasDirtyData: (dirtyData: boolean) => void
}

const CreditCardPayment: React.FC<CreditCardProps> = ({ recurlyErrors, hasDirtyData }) => {
  const { t: translate } = useTranslation()

  useEffect(() => {
    recurly.configure({
      style: {
        all: {
          height: '32px',
        },
        number: {
          placeholder: {
            content: 'XXXX XXXX XXXX XXXX',
          },
          style: {
            height: '32px',
          },
        },
        month: {
          placeholder: 'MM',
        },
        year: {
          placeholder: 'YYYY',
        },
        cvv: {
          placeholder: {
            content: 'XXX',
          },
        },
      },
    })
  }, [])

  return (
    <form
      autoComplete="off"
      id="recurly-form"
      onChange={() => {
        hasDirtyData(true)
      }}
      className={'t-admin-signup-credit-card-payment'}
    >
      <Row className="form__row">
        <Col lg={24}>
          <div className="form-field">
            <div className="input-wrapper">
              <label className="formik-field__input-label">
                {translate('admin-signup.subscription.payment.card-number-label')}
              </label>
              <div data-recurly="number" className={'t-admin-signup-credit-card-number'}></div>
            </div>
          </div>
          {recurlyErrors.get('number') ? <Error>{recurlyErrors.get('number')}</Error> : null}
        </Col>
      </Row>

      <Row className="form__row" gutter={10}>
        <Col lg={12}>
          <div className="input-wrapper">
            <label className="formik-field__input-label">{translate('general.first-name')}</label>
            <input
              type="text"
              data-recurly="first_name"
              className="ant-input formik_input input__no-autofill-color t-admin-signup-credit-card-first-name"
            />
          </div>
          {recurlyErrors.get('first_name') ? <Error>{recurlyErrors.get('first_name')}</Error> : null}
        </Col>
        <Col lg={12}>
          <div className="input-wrapper">
            <label className="formik-field__input-label">{translate('general.last-name')}</label>
            <input
              type="text"
              data-recurly="last_name"
              className="ant-input formik_input input__no-autofill-color t-admin-signup-credit-card-last-name"
            />
          </div>
          {recurlyErrors.get('last_name') ? <Error>{recurlyErrors.get('last_name')}</Error> : null}
        </Col>
      </Row>

      <Row className="form__row" gutter={10}>
        <Col lg={8}>
          <div className="input-wrapper">
            <label className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.expiration-month-label')}
            </label>
            <div data-recurly="month" className={'t-admin-signup-credit-card-month'}></div>
          </div>
          {recurlyErrors.get('month') ? <Error>{recurlyErrors.get('month')}</Error> : null}
        </Col>
        <Col lg={8}>
          <div className="input-wrapper">
            <label htmlFor="bankName" className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.expiration-year-label')}
            </label>
            <div data-recurly="year" className={'t-admin-signup-credit-year'}></div>
          </div>
          {recurlyErrors.get('year') ? <Error>{recurlyErrors.get('year')}</Error> : null}
        </Col>
        <Col lg={8}>
          <div className="input-wrapper">
            <label className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.cvv-label')}
            </label>
            <div data-recurly="cvv" className={'t-admin-signup-credit-card-cvv'}></div>
          </div>
          <div className="cvv_info">
            <Tooltip position="bottom" title={translate('admin-signup.subscription.payment.cvv-info-description')}>
              <Icon type="question-circle" className="cvv_info_icon" />{' '}
              <label className="cvv_info_label">{translate('admin-signup.subscription.payment.cvv-info-label')}</label>
            </Tooltip>
          </div>

          {recurlyErrors.get('cvv') ? <Error>{recurlyErrors.get('cvv')}</Error> : null}
        </Col>
      </Row>
      {/* recurly complains if country is absent, even though it's set up for no address requirement */}
      <input type="hidden" name="recurly-country" data-recurly="country" value="US" />
      <input type="hidden" name="recurly-token" data-recurly="token" />
    </form>
  )
}

export default CreditCardPayment
